module.exports = __webpack_public_path__ + "static/ic_play.8244d2ff.png";